<template>
  <div class="proposal-evaluation-document row">
    <div class="col-12 px-0">
      <callout
        :controlled="true"
        :has-border="false"
        has-gradient
        has-toggle
        :opened="isCalloutOpen"
        @click:open="showDocuments"
      >
        <div class="header">
          <span>{{ title }}</span>
        </div>

        <div slot="edition" class="document-container">
          <div
            v-for="(document, idx) of page.data"
            :key="idx"
            class="document-container__element"
          >
            <document-info bg-color="white" :document="document" />
          </div>
          <pagination
            v-if="page.totalItemCount > pageSize"
            :data="page"
            :page-size="pageSize"
            @pagination-go-page="setCurrentPage"
          />
        </div>
      </callout>
    </div>
  </div>
</template>

<script>
import Pagination from 'pagination';
import Callout from 'custom-callout';
import DocumentInfo from '@/views/provider/proposalHistory/components/DocumentInfo.vue';
import { getProposalEvaluationDocuments } from '@/modules/serviceProposalHistory/api';

export default {
  name: 'ProposalEvaluationDocuments',
  components: {
    Callout,
    Pagination,
    DocumentInfo,
  },
  props: {
    proposalRequestId: {
      type: Number,
      default: () => 0,
    },
    title: {
      type: String,
      required: true,
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    page: {
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
      data: [],
    },
    pageSize: 5,
    isCalloutOpen: false,
  }),
  methods: {
    async setCurrentPage(pageNumber) {
      if (this.documents.length) {
        this.page.data = this.documents;
      } else {
        this.page.currentPage = pageNumber;
        await this.searchDocuments();
      }
    },
    showDocuments() {
      this.isCalloutOpen = !this.isCalloutOpen;
      if (this.isCalloutOpen) {
        this.setCurrentPage(1);
      }
    },
    async searchDocuments() {
      const params = {
        pageIndex: this.page.currentPage,
        pageSize: this.pageSize,
      };
      await getProposalEvaluationDocuments(this.proposalRequestId, params).then(
        (res) => {
          const documents = res.data;
          this.page = {
            count: documents.count,
            totalItemCount: documents.totalItemCount,
            pageCount: documents.pageCount,
            data: documents.data,
            currentPage: documents.currentPage,
          };
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.proposal-evaluation-document::v-deep {
  margin-top: 1rem;
  margin-bottom: 1rem;

  em {
    padding-left: 5px;
    padding-right: 5px;
  }
  .border--top {
    border-top-width: 0px;
  }
  .gradient-toggle-mob {
    display: none;
  }
  .gradient-toggle {
    display: flex !important;
  }
  .header {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 1.25rem;
    color: gray;
    font-weight: bold;
  }
  .document-container {
    margin-top: 3px;
    padding: 10px;

    &__element {
      margin-bottom: 12px;
      &:first-child {
        margin-top: 6px;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .header {
      font-size: 1rem;
    }
  }
}
</style>
